/* 
 	* 车辆档案之基本信息组件 
 	* 描述：对应车辆的基本信息编辑
 	* 创建时间：2017-03-31
 	* 创建人：Shujuan Sun
 	* 修改人：zhanlz 
 	* 修改时间：2017-04-21
*/
<template>
	<div class="pl10px pr10px" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">服务卡号</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="vehicleInfo.vehicleAccount">
				</div>
				<label class="col-sm-1 control-label t_right">服务起始日</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="vehicleInfo.serviceStartTime">
				</div>
				<label class="col-sm-1 control-label t_center">服务结束日</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="vehicleInfo.serviceEndTime">
				</div>
			</div>
		</div>
		<div class="form-horizontal ibox-content">
			<br />
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">车辆品牌</label>
				<div class="col-sm-3">
					<select2 :options="vehicleBrands" v-model="vehicleInfo.brandId" v-if="isRender">
					</select2>
					<!--<select class="form-control" v-model="vehicleInfo.brandId" @input="$v.vehicleInfo.brandId.$touch()">
						<option v-for="option in vehicleBrands" v-bind:value="option.id">
							{{ option.brandName }}
						</option>
					</select>-->
				</div>
				<label class="col-sm-1 control-label t_center">车系</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="vehicleInfo.serialId">
						<option v-for="option in vehicleSerials" v-bind:value="option.id">
							{{ option.serialName }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center">车型</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="vehicleInfo.modelId">
						<option v-for="option in vehicleModels" v-bind:value="option.id">
							{{ option.modelName }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">变速器</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="vehicleInfo.transmission">
						<option v-for="option in vehicleTransmission" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center">排量(升)</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="vehicleInfo.displacement">
				</div>
				<label class="col-sm-1 control-label t_center">颜色</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="vehicleInfo.color">
						<option v-for="option in vehicleColor" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">座位</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="vehicleInfo.seat">
						<option v-for="option in vehicleSeat" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center">款型</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="vehicleInfo.style">
						<option v-for="option in vehicleStyle" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center">燃油类型</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="vehicleInfo.fuelType">
						<option v-for="option in vehicleFueltype" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
			</div>
		</div>
		<div class="form-horizontal">
			<br />
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">平均油耗</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="vehicleInfo.avgOil">
				</div>
				<label class="col-sm-1 control-label t_center">车辆短备注</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="vehicleInfo.vehicleNum" maxlength="255">
				</div>
			</div>
		</div>
		<div class="form-horizontal ibox-content">
			<br />
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">车牌号</label>
				<div class="col-sm-3">
					<vplate-input type="text" class="form-control" v-model.trim="vehicleInfo.plateNumber"/>
				</div>
				<label class="col-sm-1 control-label t_center">车辆登记日期</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="vehicleInfo.startSaleTime">
				</div>
				<label class="col-sm-1 control-label t_center">VIN/车架号</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="vehicleInfo.frameNo">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">发动机号</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="vehicleInfo.engineNumber">
				</div>
			</div>
		</div>
		<div class="form-horizontal">
			<br />
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">销售日期</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="vehicleInfo.startSaleTime">
				</div>
				<label class="col-sm-1 control-label t_center">销售顾问</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="vehicleInfo.saler">
				</div>
				<label class="col-sm-1 control-label t_center">新车购价</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="vehicleInfo.vehiclePrice">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">备注</label>
				<textarea rows="6" class="col-sm-11" v-model="vehicleInfo.memo" maxlength="250"></textarea>
			</div>
			<div class="form-group t_center">
				<button v-if="permission.indexOf('fileCarList_baseInfoSave') == -1" class="btn btn-primary" @click="ensureSave">保存基本信息</button>
			</div>
		</div>
		
		<!--   弹出框子组件        -->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示">
			{{messageStr}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeModal">取消</button>
		        <button class="btn btn-primary" @click="saveInfo">确定</button>
		    </div>
		</tab-modal>
	</div>
</template>
<script>

	import { OPERATE_EXCEPTION, OPERATE_SUCCESS, SAVE_ENSURE } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import {DICTIONARY_MAP} from 'static/constant'
	import {getDictionaryFromArray} from 'util/util'
	import classlist from 'util/classlist'
	import Select2 from 'components/common/Select2'
	
	export default {
		name: 'DetailBasic',
		components: {
		   TabModal,
		   Select2
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["fileCarList"]?this.$store.state.permission.permission["fileCarList"]:[],
				loadingstatus:false,
				vehicleInfo: {
					vehicleAccount: "",		    // 服务卡号
					serviceStartTime:'',		// 服务开始时间
					serviceEndTime:'',			// 服务结束时间
					brandId:'',					// 当前品牌ID
					vehicleBrand: '',			// 当前品牌名称
					serialId:'',				// 当前车系ID
					vehicleSerie: '',			// 当前车系名称
					modelId:'',					// 当前车型ID
					vehicleType: '', 			// 当前车型名称
					transmission:'',			// 当前变速器
					displacement:'',			// 当前排量
					color:'',					// 当前颜色
					seat:'',					// 当前座位
					style:'',					// 当前款型
					fuelType:'',				// 当前燃油类型
					vehicleNum:'',				// 车辆短备注
					memo:'',					// 备注
					plateNumber:'',				// 车牌号
					avgOil:'',					// 平均油耗
					startSaleTime:'',			// 登记日期/销售日期
					frameNo:'',					// VIN/车架号
					engineNumber:'',        	// 发动机号
					saler:'',					// 销售顾问
					vehiclePrice:'',		    // 新车购置价
				},
				vehicleBrands: [],				// 品牌列表
				vehicleSerials: [],				// 车系列表
				vehicleModels: [],				// 车型列表
				vehicleTransmission: [],		// 变速器列表
				vehicleColor: [],				// 颜色列表
				vehicleStyle: [],				// 车辆类型
				vehicleSeat: [],				// 座位列表
				vehicleFueltype:[],			    // 燃油类型
				scrollTop: "0px",
				messageStr:"",
				isRender:false
			}
		},
		beforeMount() {
			Object.assign(this.vehicleInfo, this.$parent.resultVehicle);
			this.getUdc();
			this.getBrandList();
		//	this.getSerialList();
		//	this.getModelList();
			console.log(this.vehicleInfo.brandId)
		},
		watch: {
			'vehicleInfo.brandId'(){
				this.getSerialList();
				this.vehicleModels = [];
			},
			'vehicleInfo.serialId'(){
				this.getModelList();
			}
		},
		methods:{
			ensureSave(){
				this.messageStr=SAVE_ENSURE;
				this.$refs.modalMsg.open();
				classlist.toggleScroll('close','#carfile-detail',this);
			},
			//保存基本信息
			saveInfo(){
				this.$refs.modalMsg.close();
				let subObj = {};
				$.extend(subObj,this.vehicleInfo);
				subObj.vehicleBrand = this.vehicleInfo.brandId;
				subObj.vehicleSerie = this.vehicleInfo.serialId;
				subObj.vehicleType  = this.vehicleInfo.modelId;		
				this.$http.put(process.env.API_ROOT + '/vehicle/vehicles/' + this.vehicleInfo.vehicleId, subObj)
				.then( res => {
					if(res.data.success){
						this.$parent.openModal(OPERATE_SUCCESS);	
						this.$parent.getBasicInfo();
					} else {
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			},
			//获取品牌列表
			getBrandList(){
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/brands')
				.then(res => {
					if(res.data.success){
						this.vehicleBrands = res.data.data;
						this.vehicleBrands.forEach(function (item,index,input) {
							  item.text = item.brandName; 
						})
						this.isRender = true
					}else{
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			},
			//获取车系列表
			getSerialList(){
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/serials',{params:{autoBrandId: this.vehicleInfo.brandId}})
				.then(res => {
					if(res.data.success){
						this.vehicleSerials = res.data.data;
					}else{
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})	
			},
			//获取车型列表
			getModelList(){
				if(!this.vehicleInfo.serialId) return;
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/models',{params:{autoSerialId: this.vehicleInfo.serialId}})
				.then(res => {
					if(res.data.success){
						this.vehicleModels = res.data.data;
					}else{
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})	
			},
			closeModal() {
				this.$refs.modalMsg.close();	
			},
			getUdc(){
				this.loadingstatus = true;
				let udcType = [
					DICTIONARY_MAP.COLOR,
					DICTIONARY_MAP.SEAT,
					DICTIONARY_MAP.STYLE,
					DICTIONARY_MAP.FUEL_TYPE,
					DICTIONARY_MAP.TRANSMISSION	
				]
				let param = udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.data.success){		
						//this.allUdc = this.data.data;
					 	this.vehicleTransmission = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.TRANSMISSION);
						this.vehicleColor = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.COLOR);
						this.vehicleFueltype =getDictionaryFromArray(res.data.data,DICTIONARY_MAP.FUEL_TYPE);
						this.vehicleSeat = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.SEAT);
						this.vehicleStyle = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.STYLE);
					 	
					}else{
						this.$parent.openModal(res.data.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.$parent.openModal(res.data.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})		
			}
		}
	}
</script>


// WEBPACK FOOTER //
// DetailBasic.vue?7f1e03da